import { defineStore } from "pinia";
import axios from "axios";
import router from "@/router"; // Assuming this path is correct

export const useAuthStore = defineStore("auth", {
    state: () => ({
        authenticated: Boolean(localStorage.getItem("user")),
        user: JSON.parse(localStorage.getItem("user")) || {},
    }),
    actions: {
        async login(credentials, redirectTo = "/") {
            try {
                await axios.post("/api/login", credentials);
                await this.fetchUser();
                router.replace(redirectTo); // Redirect to the original destination after login
            } catch (error) {
                console.error("Login failed:", error);
                // You might want to add error handling here, e.g., set an error state
                throw error; // Re-throw to allow components to catch and display errors
            }
        },
        async fetchUser() {
            try {
                const { data } = await axios.get("/api/me");
                localStorage.setItem("user", JSON.stringify(data));
                this.authenticated = true;
                this.user = data;
            } catch (error) {
                console.error("Failed to fetch user:", error);
                this.clearAuthState();
                throw error; // Re-throw to allow components to catch errors
            }
        },

        async logout(shouldRequestServer = true) {
            if (shouldRequestServer) {
                try {
                    await axios.post("/api/logout");
                } catch (error) {
                    console.error("Logout failed:", error);
                }
            }

            this.clearAuthState();
            router.replace("/login"); // Redirect to login page after logout
        },

        clearAuthState() {
            localStorage.removeItem("user");
            this.authenticated = false;
            this.user = null;
            delete window.axios.defaults.headers.common["Authorization"];
        },

        async initializeAuth() {
            console.log("initializeAuth . . . . . ");
            if (localStorage.getItem("user")) {
                this.authenticated = true;
                this.user = JSON.parse(localStorage.getItem("user")) || {};

                try {
                    await this.fetchUser();
                } catch (error) {
                    console.error("Failed to initialize auth:", error);
                    this.clearAuthState();
                }
            }
        },
    },
});
